'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import { Divider } from '@sola/ark-core/atoms/divider/divider.tsx';
import { AddressSelectSupporter } from '@sola/ark-core/molecules/address-select/address-select-supporter.tsx';
import { Fieldset } from '@sola/ark-core/molecules/fieldset/fieldset.tsx';
import { Form, FormProps, useFormMethods } from '@sola/ark-core/molecules/form/form.tsx';
import { ArkIcon } from '@sola/ark-icons/lib/ark-icon.tsx';
import { GraphQLCommitment, GraphQLSupporterPaymentMethod } from '@sola/schema/dotcom/supporters/schema.generated.ts';
import { IconNames } from '@sola/schema/lib/icons/icon-names.ts';
import { getIconName } from '../../atoms/payment-method-icon/payment-method-icon.tsx';
import { RecurringGivingOptions } from '../../organisms/recurring-giving-options/recurring-giving-options.tsx';
import { getPaymentMethodLabel } from '../../utils/payment-methods.ts';
import { SectionContent } from '../section-content/section-content.tsx';
import { UpdateACHFields } from './update-ach-fields.tsx';
import { UpdateCCFields } from './update-cc-fields.tsx';
export type PaymentMethodUpdateFormProps = {
  paymentMethod: GraphQLSupporterPaymentMethod;
  nonRecurringCommitments?: GraphQLCommitment[] | null;
  children: React.ReactNode;
  onSubmit: FormProps['onSubmit'];
};
export const PaymentMethodUpdateForm: React.FC<PaymentMethodUpdateFormProps> = t0 => {
  const $ = _c(20);
  const {
    paymentMethod,
    nonRecurringCommitments,
    children,
    onSubmit
  } = t0;
  const {
    t
  } = useTranslation("my");
  const formMethods = useFormMethods();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      mode: "onTouched"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== paymentMethod || $[2] !== t) {
    t2 = paymentMethod.ach && <SectionContent heading={t("payments.methodForm.formTitle.bank")}><div className="w-full flex flex-col gap-comfy-xl"><div className="flex flex-row gap-comfy-xs md:gap-comfy-md items-center"><ArkIcon className="PaymentMethodUpdateSheet__icon" iconName={getIconName(paymentMethod) as IconNames} /><span className="block label-md label-moderate md:label-lg label-neutral-potent mb-snug-md">{getPaymentMethodLabel(paymentMethod, t)}</span></div><Fieldset id="ach-fields"><UpdateACHFields paymentMethod={paymentMethod} /></Fieldset></div></SectionContent>;
    $[1] = paymentMethod;
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== paymentMethod || $[5] !== t) {
    t3 = paymentMethod.creditCard && <><SectionContent heading={t("payments.methodForm.formTitle.card")}><div className="w-full flex flex-col gap-comfy-xl"><div className="flex flex-row gap-comfy-xs md:gap-comfy-md items-center"><ArkIcon className="PaymentMethodUpdateSheet__icon" iconName={getIconName(paymentMethod) as IconNames} /><span className="block label-md label-moderate md:label-lg label-neutral-potent mb-snug-md">{getPaymentMethodLabel(paymentMethod, t)}</span></div><Fieldset id="cc-fields"><UpdateCCFields paymentMethod={paymentMethod} /></Fieldset></div></SectionContent><Divider purpose="neutral" className="my-comfy-xl" /><SectionContent heading={t("payments.methodForm.formTitle.billingInfo")}><AddressSelectSupporter label={t("payments.methodForm.fieldLabels.billingInfo")} paymentMethod={paymentMethod} /></SectionContent></>;
    $[4] = paymentMethod;
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Divider purpose="neutral" className="my-comfy-xl" />;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== nonRecurringCommitments || $[9] !== t) {
    t5 = !!nonRecurringCommitments?.length && <SectionContent heading={t("payments.methodForm.formTitle.recurringGiving")}><RecurringGivingOptions commitments={nonRecurringCommitments} /></SectionContent>;
    $[8] = nonRecurringCommitments;
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== children || $[12] !== t2 || $[13] !== t3 || $[14] !== t5) {
    t6 = <div>{t2}{t3}{t4}{t5}{children}</div>;
    $[11] = children;
    $[12] = t2;
    $[13] = t3;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== formMethods || $[17] !== onSubmit || $[18] !== t6) {
    t7 = <Form onSubmit={onSubmit} formMethods={formMethods} options={t1} isCustomError={true} noValidate={true}>{t6}</Form>;
    $[16] = formMethods;
    $[17] = onSubmit;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  return t7;
};